import { Box, Stack } from '@stitch-fix/mode-react';
import { ContentStackJSONRichText } from '../../../scripts/schemaGenerator/fields/rte';
import { GetStartedButton } from '../GetStartedButton';
import { JsonRteRenderer } from '../JsonRteRenderer';
import { InteractiveImageScroller, InteractiveImageScrollerProps } from './InteractiveImageScroller';
import { buttonColorToButtonVariant } from '../ModuleFooter/ModuleFooter';
import { useStickyCtaContext } from '../StickyCta/useStickyCtaContext';
import { isEmpty } from '../JsonRteRenderer/JsonRteRenderer';
import styles from './styles.module.scss';
export type InteractiveImageScrollerHeroProps = {
  images: InteractiveImageScrollerProps['images'];
  title: ContentStackJSONRichText;
  subtitle: ContentStackJSONRichText;
  fontColor: 'white' | 'gray-16' | 'blue-45' | 'forest-60' | 'grapefruit-60';
  cta: {
    title: string;
    href: string;
  };
  buttonColor: string;
  backgroundColor: 'mint-60' | 'blue-45' | 'gray-99' | 'citrus-60' | 'forest-60' | 'grapefruit-60' | 'white';
};
export const InteractiveImageScrollerHero = ({
  images,
  title,
  subtitle,
  fontColor,
  cta,
  buttonColor,
  backgroundColor
}: InteractiveImageScrollerHeroProps) => {
  const {
    setStickyContainerTarget
  } = useStickyCtaContext();
  return <Box className={styles.heroContainer} bgColor={backgroundColor}>
      <Stack hAlign="center" spacing={1} ref={setStickyContainerTarget}>
        <Box px={1}>
          <JsonRteRenderer data={title} options={{
          textProps: {
            h1: {
              color: fontColor,
              spacingBottom: false,
              align: 'center'
            }
          }
        }} />
        </Box>
        {!isEmpty(subtitle?.children) && <Box px={1}>
            <JsonRteRenderer data={subtitle} options={{
          textProps: {
            p: {
              color: fontColor,
              spacingBottom: false
            },
            li: {
              color: fontColor,
              spacingBottom: false
            }
          }
        }} />
          </Box>}

        <InteractiveImageScroller images={images} alignment="center" backgroundColor={backgroundColor} isScrollerHero imageProps={{
        loading: 'eager',
        fetchPriority: 'high'
      }} />

        <GetStartedButton mt={0.25} copy={cta.title} href={cta.href} variant={buttonColorToButtonVariant(buttonColor)} eventLocation="hero" />
      </Stack>
    </Box>;
};